import React, { Component } from 'react'
import { connect } from 'react-redux'
import FontAwesome from 'react-fontawesome'
import moment from 'moment'
import numeral from 'numeral'

import Box from '../components/Layout/Box'
import BoxButton from '../components/Layout/BoxButton'
import BoxSection from '../components/Layout/BoxSection'
import ButtonStrip from '../components/Layout/ButtonStrip'
import ModalDelete from '../components/Parametros1/ModalDelete'

import { transformParameterData } from '../utils/helpers'

import {
    getParametros,
    updateInputs,
    addNewParameterDetail,
    createOrUpdateParametros,
    toggleSelectAllItems,
    deleteParametros,
    showHideModalDelete
} from '../actions/parametros1'

import history from '../utils/history'
import { Map } from 'immutable'

export function findValues(c, x) {
	let value = x.get(c.get('value')) || Map({})
	return value
}

class Parametros1 extends Component {
    componentWillMount() {
        this.props.getParametros()
    }

	render() {
        const { parametros } = this.props
        const boxActions = [
            <BoxButton key="ba[0]" name="floppy-o" onClick={ e => this.props.createOrUpdateParametros() } title="Guardar"/>,
        ]

		return (
            <div className="row" style={{ height: '100%' }}>
                <div className="col-md-12" style={{ height: '100%' }}>
                    <Box title="Parametros" stretch>
                        <ButtonStrip 
                            actions={ boxActions }
                        />
                        <div className="box-content" style={{ flex: 1, height: 0, overflow: 'auto' }}>
                            {
                                parametros.map((x, j) => {
                                    const boxActions = [
                                        <BoxButton size={14} contrast key={ `ba[${j}][0]` } name="plus-circle" onClick={ e => this.props.addNewParameterDetail(j) } title="Nueva" style={{ marginTop: '-4px' }} />,
                                        <BoxButton size={14} contrast key={ `ba[${j}][1]` } name="trash" onClick={ e => this.props.showHideModalDelete(true, `Esta seguro que desea eliminar los Parametros seleccionados?`, () => this.props.deleteParametros(j)) } title="Eliminar" style={{ marginTop: '-4px' }} disabled={ x.get('data').filter(d => d.get('selected')).count() === 0 } danger />,
                                    ]

                                    return (
                                        <div key={ x.getIn(['parametro', 'nombre']) }>
                                            <BoxSection title={ x.getIn(['parametro', 'nombre']) } actions={ boxActions }>
                                                <table className="table table-condensed table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th width="20px">
                                                                <input type="checkbox" style={{ verticalAlign: 'middle' }} onChange={ e => this.props.toggleSelectAllItems(j, e.target.checked) } checked={ x.get('data').filter(x => x.get('selected')).count() > 0 && x.get('data').filter(x => x.get('selected')).count() >= x.get('data').count() } />
                                                            </th>
                                                            {
                                                                x.get('columnas').map(p => {
                                                                    return (
                                                                        <th key={ `th[${x.getIn(['parametro', 'Nombre'])}][${p.get('id')}]` }>{ p.get('caption') }</th>
                                                                    )
                                                                })
                                                            }
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            x.get('data').count() > 0 ? x.get('data').map((p, n) => {
                                                                return (
                                                                    <tr key={ `tr[${x.getIn(['parametro', 'nombre'])}][${p.get('registro')}]` } className={ p.get('selected') ? 'info' : '' }>
                                                                        <td>
                                                                            <input type="checkbox" style={{ verticalAlign: 'bottom' }} onChange={ e => this.props.updateInputs(`parametros.${j}.data.${n}.selected`, e.target.checked) } checked={ p.get('selected') } />
                                                                        </td>
                                                                        {
                                                                            x.get('columnas').map(c => {
                                                                                const foundVal = findValues(c, p)
                                                                                let value = foundVal.get('valor')
                                                                                let id = foundVal.get('id')
                                                                                
                                                                                if (c.get('Type')) {
                                                                                    switch (c.get('type')) {
                                                                                        case 'datetime':
                                                                                            value = moment(value).format(c.get('format'))
                                                                                            break
                                                                                        case 'bool':
                                                                                            value = value = <div style={{ textAlign: 'center', fontSize: '1.1em' }}><i className={`fa fa-${value ? 'check-' : ''}square`} /></div>
                                                                                            break
                                                                                        case 'number':
                                                                                            value = numeral(value).format(c.get('format'))
                                                                                            break
                                                                                        default:
                                                                                    }
                                                                                }

                                                                                return (
                                                                                    <td key={ `td1[${x.get('id')}][${foundVal.get('guid')}]` }>
                                                                                        <input className="form-control input-sm" value={ value } onChange={ (e) => this.props.updateInputs(`parametros.${j}.data.${n}.${c.get('value')}.valor`, e.target.value) } />
                                                                                    </td>
                                                                                )
                                                                            })
                                                                        }
                                                                    </tr>
                                                                )
                                                            }) : <tr><td colSpan={ x.get('columnas').count() + 1 }>No existen registros</td></tr>
                                                        }
                                                    </tbody>
                                                </table>
                                            </BoxSection>
                                            <div className="separator"/>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </Box>
                </div>
                <ModalDelete />
            </div>
		)
	}
}

function mapStateToProps(state) {
    return {
        parametros: state.parametros1.get('parametros')
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getParametros: () => dispatch(getParametros()),
		updateInputs: (path, value) => dispatch(updateInputs(path, value)),
        addNewParameterDetail: (parametroId) => dispatch(addNewParameterDetail(parametroId)),
        createOrUpdateParametros: () => dispatch(createOrUpdateParametros()),
        toggleSelectAllItems: (parametroIndex, checked) => dispatch(toggleSelectAllItems(parametroIndex, checked)),
        deleteParametros: (parametroIndex) => dispatch(deleteParametros(parametroIndex)),
		showHideModalDelete: (open, message, action) => dispatch(showHideModalDelete(open, message, action)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Parametros1)


// WEBPACK FOOTER //
// ./src/containers/Parametros1.jsx